/**
 * Import all module dependencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import securityquestionRsa from './rsa/rsa.module';
import securityquestionRoute from './securityquestion.route';
import securityquestionController from './securityquestion.controller';
/**
 * This is the securityquestion module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace securityquestion Module
 */
angular.module('securityquestion', [
  // Shared modules.
  core,
  securityquestionRsa
])
// Register route.
.config(securityquestionRoute)
// Register controller.
.controller('securityquestionController', securityquestionController);

export default 'securityquestion';


// WEBPACK FOOTER //
// ./src/login/securityquestion/securityquestion.module.js